/* eslint-disable camelcase */
import axios from "axios";
import config from "config/config";
import { getParentLanguage } from "utils/localeUtils";

const getCoralLanguage = (language) => (language === "pt-br" ? language : getParentLanguage(language));

const registerUser = async (campaignId, language, email, source) => {
  const url = `${config.coral.url}/api/users`;

  const data = {
    campaign_id: parseInt(campaignId, 10),
    language: getCoralLanguage(language),
    email,
    source,
  };

  const headers = {
    "Content-Type": "application/json",
  };

  return axios.post(url, data, headers);
};

export default registerUser;
